// Classes.
import { AthleteGeneralInfoItem } from "../types/athlete-general-info.item";
import { TeamGeneralInfoItem } from "../types/team-general-info.item";
import { AthleteResultInfoLiteItem } from "../types/athlete-result-info-lite.item";

// Services.
import { FactoryService } from "../../wa-services/factory-service";
import { SeriesAmateursDetailItem } from "./series-amateurs-detail-item";

export class RankingItem {
  public rank: number;
  public rankPrevious: number;
  public catCode: string;
  public athlete: AthleteGeneralInfoItem;
  public team: TeamGeneralInfoItem;
  public points: number;
  public issued: Date;
  public status: number;
  public statustext:string
  public results: AthleteResultInfoLiteItem[] = [];
  public details: SeriesAmateursDetailItem[] = [];
  public score: number;
  protected _variance: number;

  constructor(rawRankingItem: any, protected factory: FactoryService) {
    this.statustext= rawRankingItem.StatusText;
    this.rank = rawRankingItem.Rnk;
    this.rankPrevious = rawRankingItem.RnkOld;
    this.catCode = rawRankingItem.Cat;
    this.points = rawRankingItem.Points;
    this.score = rawRankingItem.Score;
    this.issued =   rawRankingItem.RnkDtIssued ?
    new Date(new Date(rawRankingItem.RnkDtIssued ).getTime() +
    Math.abs(new Date(rawRankingItem.RnkDtIssued ).getTimezoneOffset() * 60000))
      : null;

    this.athlete = rawRankingItem.Athlete;
    this.status = rawRankingItem.Status;
    this.team = rawRankingItem.Team;

    // If there's detailed info process it.

    this.details = rawRankingItem.Details;

    // Calculate how many positions the rank has moved.
    this._variance = this.rankPrevious - this.rank;
  }

  public get variance(): number {
    return this._variance;
  }

  public get rankLabel(): string {
    return RankingItem.rankToLabel(this.rank);
  }

  public get rankPreviousLabel(): string {
    return RankingItem.rankToLabel(this.rankPrevious);
  }

  protected static rankToLabel(rank: number): string {
    return rank ? rank + "" : "-";
  }
}
